import CreateOrderPage from '@/pages/shared/CreateOrderPage'

/**
 * Sales is always its own PIC, can never bypass the production quota and
 * cannot put an order on credit - the sales endpoint refuses all three. It
 * may agree a price per piece (client 2026-10-05: in-house prices are flexible).
 */
export default function SalesCreateOrder() {
  return <CreateOrderPage basePath="/sales" canChoosePic={false} canBypassQuota={false} canOrderOnCredit={false} canAgreePrice />
}
